/**
 * @generated SignedSource<<c90ab19b083d6057cbb6c7b87f8e2772>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductBaseTile_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ProductDetails_item" | "ProductPrice_item" | "ProductShipping_item" | "ProductTitle_item">;
  readonly " $fragmentType": "ProductBaseTile_item";
};
export type ProductBaseTile_item$key = {
  readonly " $data"?: ProductBaseTile_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductBaseTile_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "isTrade"
    },
    {
      "defaultValue": "searchAndBrowse",
      "kind": "LocalArgument",
      "name": "pageDisplayEnum"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "priceBookName"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductBaseTile_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProductTitle_item"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "isTrade",
          "variableName": "isTrade"
        },
        {
          "kind": "Variable",
          "name": "pageDisplayEnum",
          "variableName": "pageDisplayEnum"
        },
        {
          "kind": "Variable",
          "name": "priceBookName",
          "variableName": "priceBookName"
        }
      ],
      "kind": "FragmentSpread",
      "name": "ProductPrice_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProductShipping_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProductDetails_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "ef0f00e01fa338211b8801f033664154";

export default node;
